import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

const LanguageToggle: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [lang, setLang] = useState<'EN' | 'SW'>('EN');

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (newLang: 'EN' | 'SW') => {
    setLang(newLang);
    handleClose();
    // In a real app, this would change the i18next language
  };

  return (
    <>
      <Tooltip title="Switch Language">
        <IconButton onClick={handleOpen} color="inherit">
          <LanguageIcon />
          <Typography variant="caption" sx={{ ml: 0.5, fontWeight: 'bold' }}>{lang}</Typography>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => handleSelect('EN')} selected={lang === 'EN'}>
          <ListItemIcon>
            <Typography variant="body2">🇺🇸</Typography>
          </ListItemIcon>
          <ListItemText>English</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleSelect('SW')} selected={lang === 'SW'}>
          <ListItemIcon>
            <Typography variant="body2">🇰🇪</Typography>
          </ListItemIcon>
          <ListItemText>Kiswahili</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default LanguageToggle;
